<ng-container *ngrxLet="nbas$ as nbas">
  <div class="cc-nba-bar">
    <ng-container *ngTemplateOutlet="primaryNbaTemplate" />
    @if ((nbas?.secondaryNbas$ | async)?.length > 0) {
      <ng-container *ngTemplateOutlet="secondaryNbasTemplate" />
    }
  </div>

  <ng-template #secondaryNbasTemplate>
    <div class="cc-nba-bar__secondary">
      @for (secondaryNba of nbas?.secondaryNbas$ | async; track secondaryNba) {
        <cc-nba-secondary-item
          [footnoteHintsTemplateRef]="footnoteHints"
          [customWidgetContainerTemplateRef]="customWidgetContainer"
          [mainItem]="secondaryNba"
          [subItems]="secondaryNba.subNbas$ | async"
          (mainItemClick)="onSecondaryNbaPopoverMainItemClick($event)"
          (subItemClick)="onSecondaryNbaPopoverSubItemClick($event)"
        />
      }
    </div>
  </ng-template>

  <ng-template #primaryNbaTemplate>
    <div class="cc-nba-bar__primary">
      @if (nbas?.primaryNba$ | async; as primaryNba) {
        <!-- if we have an attached config in the primary nba config we will show am additionally secondary button in the primary nbas -->
        @if (primaryNba?.attachedConfig) {
          <ng-container
            *ngTemplateOutlet="
              primaryButton;
              context: { nba: primaryNba.attachedConfig, variant: 'secondary', additionallyTrackVariant: true }
            "
          />
        }
        @if (primaryNba) {
          <ng-container
            *ngTemplateOutlet="
              primaryButton;
              context: { nba: primaryNba, variant: 'primary', additionallyTrackVariant: !!primaryNba?.attachedConfig }
            "
          />
        }
      }
    </div>
  </ng-template>
</ng-container>

<ng-template
  #customWidgetContainer
  let-customWidget="customWidget"
  let-saveLabel="saveLabel"
  let-savedLabel="savedLabel"
>
  @if (customWidget === customWidgetEnum.WishlistSaveButton) {
    <!-- intentionally slot icon to prevent line break -->
    <cc-wishlist-save-button
      class="wishlist-patch"
      [slot]="!saveLabel ? 'icon' : ''"
      [saveLabel]="saveLabel"
      [savedLabel]="savedLabel"
      [isFullWidth]="true"
      [isFullFunctionalButton]="true"
      [showLabelOnMobile]="true"
      size="l"
      saveColor="primary"
      savedColor="primary"
    />
  }
</ng-template>

<ng-template #footnoteHints let-footnoteHints="footnoteHints">
  @for (hint of footnoteHints; track hint) {
    <cc-footnote-hint [hint]="hint" component="nbaBar" />
  }
</ng-template>

<ng-template #primaryButton let-nba="nba" let-variant="variant" let-additionallyTrackVariant="additionallyTrackVariant">
  @if (nba?.htmlElementType === 'link') {
    <a
      [href]="nba?.href$ | async"
      [ccTrackClick]="{
        action: nba?.trackingPosition,
        label: nba?.trackingLinkName + (additionallyTrackVariant ? '.' + variant : ''),
        category: 'link'
      }"
      target="_blank"
      rel="noopener"
    >
      <ccwb-button
        class="wb-margin-end-3xs cc-nba-bar__primary-button cc-nba-primary-link-button"
        [variant]="variant"
        size="l"
      >
        @if (nba?.icon) {
          <ccwb-icon [name]="nba?.icon" />
        }
        {{ nba?.label | translate: returnTranslationOrKey }}
      </ccwb-button>
    </a>
  }

  @if (nba?.htmlElementType === 'button') {
    @if (nba?.customWidget) {
      <ng-container
        *ngTemplateOutlet="
          customWidgetContainer;
          context: { customWidget: nba?.customWidget, saveLabel: nba?.label, savedLabel: nba?.savedToAccountLabel }
        "
      />
    } @else {
      <ccwb-button
        class="wb-margin-end-3xs cc-nba-bar__primary-button"
        [variant]="variant"
        [ccTrackClick]="{
          action: nba?.trackingPosition,
          label: nba?.trackingLinkName + (additionallyTrackVariant ? '.' + variant : ''),
          category: 'link'
        }"
        (click)="onPrimaryNbaClick({ rootEvent: $event, item: nba })"
        size="l"
      >
        @if (nba?.icon) {
          <ccwb-icon [name]="nba?.icon" />
        }
        {{ nba?.label | translate: returnTranslationOrKey }}
      </ccwb-button>
    }
  }
</ng-template>
